import { featureRoute } from '../../../../src/routes/helpers';
import { CompensationPages } from '../../../../src/constants/AppConstants';

export default featureRoute('enableCompensationWhitelist', CompensationPages.PRE_APPROVED, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/compensation/Whitelist').default);
        }, 'compensation-whitelist');
    }
});
